// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dnav
{
    width:100%;
    background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    height:50px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.user_avatar{
    font-size: 35px;
    position: relative;
    left: 540px;
    cursor: pointer;
}
.Logo
{
  background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,9,9,1) 35%, rgba(0,212,255,1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.profile_box {
    position: absolute;
    top: calc(100% + 3px);
    right: 0;
    width: 200px;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 1rem;
    display: none;

  }
  
  .user_avatar:hover .profile_box {
    display: block;
  }
  
  .profile_box p {
    margin-top: 0;
    font-size: 16px;
    text-align: center;
    color: #333;
  }
  
  .profile_box p {
    margin-bottom: 0.5rem;
  }
  
  .logout_btn {
    cursor: pointer;
    background-color: #dc3545;
    color: #fff;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    transition: background-color 0.3s;
    margin-left: 40px;
  }
  
  .logout_btn:hover {
    background-color: #c82333;
  }

`, "",{"version":3,"sources":["webpack://./src/components/Dnavbar.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,mEAAmE;IACnE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;;EAEE,kGAAkG;EAClG,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,aAAa;;EAEf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".Dnav\r\n{\r\n    width:100%;\r\n    background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\r\n    height:50px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.user_avatar{\r\n    font-size: 35px;\r\n    position: relative;\r\n    left: 540px;\r\n    cursor: pointer;\r\n}\r\n.Logo\r\n{\r\n  background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,9,9,1) 35%, rgba(0,212,255,1) 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n.profile_box {\r\n    position: absolute;\r\n    top: calc(100% + 3px);\r\n    right: 0;\r\n    width: 200px;\r\n    background-color: #fff;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\r\n    border-radius: 5px;\r\n    padding: 1rem;\r\n    display: none;\r\n\r\n  }\r\n  \r\n  .user_avatar:hover .profile_box {\r\n    display: block;\r\n  }\r\n  \r\n  .profile_box p {\r\n    margin-top: 0;\r\n    font-size: 16px;\r\n    text-align: center;\r\n    color: #333;\r\n  }\r\n  \r\n  .profile_box p {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  \r\n  .logout_btn {\r\n    cursor: pointer;\r\n    background-color: #dc3545;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 5px;\r\n    transition: background-color 0.3s;\r\n    margin-left: 40px;\r\n  }\r\n  \r\n  .logout_btn:hover {\r\n    background-color: #c82333;\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
